<template>
  <AppLayout>
    <h1> {{ $t('verifyAuthCodePage.title') }} </h1>
    <form @submit.prevent="handleSubmit">
      <FormAuthCode v-model="authCode" :error="verificationError" />
      <p v-if="verificationError" class="error"> {{ $t('verifyAuthCodePage.code-incorrect') }} </p>
      <p> {{ $t('verifyAuthCodePage.enter-code') }} </p>

      <FormCheckbox v-model="saveMFA" class="remember-mfa"> {{ $t('verifyAuthCodePage.remember') }} </FormCheckbox>

      <AuthCodeResendLink
        :auth-code="authCode"
        :login-email="$store.state.auth.email"
        :login-password="$store.state.auth.password"
      />

      <div class="submit">
        <ButtonGreen :busy="submitting" :disabled="!canBeSubmitted" :icon="$icons.continue" type="submit">
          {{ $t('verifyAuthCodePage.continue') }}
        </ButtonGreen>
      </div>
    </form>
  </AppLayout>
</template>

<script>
  import AppLayout from '../components/AppLayout';
  import FormInput from '../components/Form/FormInput';
  import FormCheckbox from '../components/Form/FormCheckbox';
  import ButtonGreen from '../components/ButtonGreen';
  import FormAuthCode from '../components/Form/FormAuthCode';
  import { getAuthorizeURL } from '@/helpers/tools.js';
  import AuthCodeResendLink from '@/components/AuthCodeResendLink';

  export default {
    name: 'VerifyAuthCodePage',
    components: { AuthCodeResendLink, FormAuthCode, ButtonGreen, FormCheckbox, FormInput, AppLayout },
    data() {
      return {
        authCode: null,
        saveMFA: false,
        verificationError: false,
        submitting: false,
      };
    },
    watch: {
      authCode(authCode) {
        if(authCode) {
          this.verificationError = false;
        }
      },
    },
    computed: {
      canBeSubmitted() {
        return this.authCode?.match(/^\d{6}$/);
      },
    },
    methods: {
      async handleSubmit() {
        try {
          this.submitting = true;
          this.verificationError = false;

          await this.$store.dispatch('authCode/verifyCode', { code: this.authCode, save: this.saveMFA });

          window.location = getAuthorizeURL();
        } catch (e) {
          this.verificationError = true;
          this.authCode = null;
          this.submitting = false;
          throw e;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .form-input {
    margin-bottom: 3rem;
  }

  .password-input {
    margin-bottom: 0;
  }

  .phone-number {
    white-space: nowrap;
  }

  .submit {
    margin-top: 15rem;
    text-align: right;
  }

  .error {
    font-weight: bold;
    color: $inputErrorColor;
  }

  .information {
    font-weight: bold;
  }

  .auth-code-resend-link {
    margin-top: 4rem;
  }
</style>
